<template>
    <div class="ai-statement" :class="subject" v-if="$i18n.locale == 'zh'">
        <!-- * AI翻译提示 -->
        <div class="ai-statement-control">
            <span @click="show = !show" :class="{ active: show }">查看原文</span> <span @click="modal?.openModal()"> 参与反馈</span>
        </div>

        <!-- * AI翻译内容 -->
        <Transition @before-enter="entrancePre" @enter="entrance" @leave="departure">
            <div class="ai-statement-content" v-show="show" v-bind="binds.content">
                <div class="ai-statement-context">
                    <slot name="content">{{ contexts.origin }}</slot>
                </div>
            </div>
        </Transition>

        <UiModal :class="css.modal" ref="modal" spacing="40px 64px" :width="1136" :min-height="600" height="auto">
            <UiForm :data="data" :rules="rules" ref="form">
                <UiFormItem :class="css.row" label="原英文文本：" direction="column">
                    <UiTextarea :class="css.origin" v-model="contexts.origin" :readonly="true"></UiTextarea>
                </UiFormItem>
                <UiFormItem :class="css.row" label="原翻译后文本：" direction="column">
                    <UiTextarea v-model="contexts.default" :readonly="true" :height="122"></UiTextarea>
                </UiFormItem>
                <UiFormItem :class="css.row" prop="opinion" label="修改意见：" direction="column">
                    <UiTextarea v-model="data.context" :maxlength="2000" :height="122" :placeholder="'请输入你的修改意见'"></UiTextarea>
                    <div :class="css.textRight">{{ computeds.inputLength }} / 2000</div>
                </UiFormItem>
            </UiForm>

            <div :class="css.footer">
                <UiButton :class="css.cencel" size="middle" :width="152" @click="modal?.closeModal()">{{ $t("Cancel") }}</UiButton>
                <UiButton :class="css.submit" size="middle" :width="152" @click="submit()">{{ $t("BioTools.Submit") }}</UiButton>
            </div>
        </UiModal>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal, UiTextarea, UiForm, UiFormItem, UiButton } from "various-ui";
//* 组件属性
import { AIStatementPropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 获取公共属性
const define = defineProps(AIStatementPropsOption);

const { refs, nodes, binds, methods, animations, computeds } = useComposable(define);
const { show, data, rules } = refs;
const { form, modal } = nodes;
const { submit } = methods;
const { entrancePre, entrance, departure } = animations;
</script>

<style lang="less" scoped>
@import "./style/index.less";
</style>
